import { useEffect, useState } from 'react';
import * as React from 'react';
import { pcontract } from '@/proto/proto';
import api from '@/api';
import { API_CONTRACT } from '@/constants/constant';

const ContractPage: React.FC = () => {
  const [contracts, setContracts] = useState<pcontract.PbContract[]>();

  useEffect(() => {
    api.get(API_CONTRACT).then(({ data }) => {
      setContracts(data.contract);
    });
  }, [contracts]);

  return (
    <>
      <h1>Contract Page</h1>
    </>
  );
};

export default ContractPage;
